export default function dynamicFilterOptions(filterOptions) {
  return Object.entries(filterOptions)
    .reduce((newObj, [key, value]) => {
      if (!value.items || value.items.length === 0) {
        return {
          ...newObj,
          [key]: value,
        };
      }

      const itemsHasCount = value.items.find((n) => Number(n.count) > 0);
      if (!itemsHasCount) return newObj;

      return {
        ...newObj,
        [key]: {
          items: value.items,
        },
      };
    }, {});
}
